<template>
    <div class="detail-container">
        <div class="main-wrapper">
            <Empty v-if="!totalPageAll"></Empty>
            <div class="reversal-courses clearfix" style="width: 1080px;margin: 0 auto;">
                <div class="online-course-list" v-for="(course, index) in courseData" @click="goDetail(course)"
                     :key="index">
                    <img :src="course[4].picurl">
                    <div class="online-course-list-title" :title="course[1].name">{{course[1].name}}</div>
                    <div class="online-course-list-detail">
                        <span>讲师:</span>
                        <span>{{course[8].teacherName}}</span>
                    </div>
                    <div class="online-course-list-line"></div>
                    <div class="online-course-list-detail" style="margin-bottom: 8px;" :title="course[9].lawfirm">
                        {{course[9].lawfirm}}
                    </div>
                    <div class="online-course-list-detail">
                        <span>课程时间:</span>
                        <span>{{parseInt(course[2].duration / 60 / 60)}}小时{{parseInt(course[2].duration / 60 - (60 * parseInt(course[2].duration / 60 / 60)))}}分钟</span>
                    </div>
                </div>
            </div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
        <Page :total="totalPageAll"
              v-if="totalPageAll"
              :current="currentIndex"
              :page-size="20"
              @on-change="handlePageIndexChanged"/>
    </div>
</template>

<script>
    import api from '@/api/calss-search'
    import Empty from "../../class-search-result/empty";

    export default {
        name: 'online-course',
        components: {Empty},
        data() {
            return {
                courseData: [],
                showPagination: false,
                page: 20,
                totalPageAll: 0,
                loadering: false,
                input: '',
                courseKey: '',
                currentIndex: 1,
                activeIndex: '1',
                loading:false
            }
        },
        watch: {
            $route(to, from) {
                let obj = {
                    key: 1,
                    pageIndex: 1,
                    keyword: this.$router.currentRoute.query.keyword
                }
                this.currentIndex = 1
                this.publicFunction(obj)
            }
        },
        created() {
            let obj = {
                key: 1,
                pageIndex: 1,
                keyword: this.$router.currentRoute.query.keyword
            }
            this.currentIndex = 1
            this.publicFunction(obj)
        },
        methods: {
            goDetail(data) {
                this.loading = true
                let win = window.open()
                let params = {
                    id: data[0].id,
                    parentid: 45
                }
                api.queryVideoDetail(params).then(data => {
                    this.loading = false
                    let newUrl = JSON.parse(data)[1].Content
                    win.location = newUrl
                })
            },
            handlePageIndexChanged(val) {
                let obj = {
                    key: '',
                    pageIndex: val,
                    keyword: this.$router.currentRoute.query.keyword
                }
                this.currentIndex = val
                this.publicFunction(obj)
            },
            publicFunction(obj) {
                this.loading = true
                let params = {
                    key: obj.key,
                    page: obj.pageIndex,
                    keyword: obj.keyword
                }
                api.queryVideoList(params).then(data => {
                    this.loading = false
                    if (data) {
                        this.courseData = JSON.parse(data)[0].courselist
                        let num =JSON.parse(data)[0].courselist[0]? JSON.parse(data)[0].courselist[0].length:0
                        this.totalPageAll = num === 0 ? 0 : Number(JSON.parse(data)[0].courselist[0][num - 1].ColumnCount)
                    }
                })
            }
        }
    }
</script>

<style lang='scss' scoped>
    .online-course-list {
        display: inline-block;
        cursor: pointer;
        width: 222px;
        height: 291px;
        box-shadow: 0 5px 15px 0 rgba(86, 86, 86, 0.12);
        background-color: #ffffff;

        img {
            width: 194px;
            height: 146px;
            margin: 14px 14px 7px 14px;
            overflow: hidden;
        }

        .online-course-list-title {
            width: 120px;
            height: 21px;
            font-size: 15px;
            font-weight: 500;
            color: #212121;
            margin-left: 14px;
            margin-bottom: 7px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .online-course-list-detail {
            height: 17px;
            font-size: 12px;
            font-weight: normal;
            color: #666666;
            margin-left: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .online-course-list-line {
            width: 194px;
            height: 2px;
            margin: 7px 0 7px 14px;
            border-bottom: solid 1px #f3f3f3;

        }
    }

    .online-course-list:not(:last-child) {
        margin: 0 26px 29px 0;
    }

    .detail-container {
        width: 942px;
        padding: 40px 0px 40px 0px;
        margin: auto;

    }


</style>
